import { ref } from '@nuxtjs/composition-api';
import { defineStore } from 'pinia';

import { accountApiConfig } from '@/config/api/account';
import { useClientApi } from '@/plugins/api/lk';
import { useSentry } from '@/plugins/sentry';
import type {
  Warnings,
  WarningsResponse,
} from '@/types/Warnings';

export const useWarningsStore = defineStore('warnings', () => {
  const warnings = ref<Warnings>([]);

  async function getWarnings (): Promise<void> {
    try {
      const url = accountApiConfig.getCautions;
      const { data } = await useClientApi().get<WarningsResponse>(url);
      const { warnings: warningsData } = data;

      warnings.value = warningsData ?? [];
    } catch (error) {
      console.error('🚀 ~ file: warning.ts ~~ getWarnings ~ e', error);
      useSentry().captureException(error);
    }
  }

  async function removeWarning (id: number): Promise<void> {
    try {
      const url = accountApiConfig.deleteCaution(id);
      await useClientApi().$delete(url);
      await getWarnings();
    } catch (error) {
      console.error('🚀 ~ file: warning.ts ~~ removeWarning ~ e', error);
      useSentry().captureException(error);
    }
  }

  return {
    warnings,
    getWarnings,
    removeWarning,
  };
});
